import {
  ADD_PLUS_ICON_PATHS,
  ALIGN_CENTER_ICON_PATHS,
  ALIGN_LEFT_ICON_PATHS,
  ALIGN_RIGHT_ICON_PATHS,
  BOLD_ICON_PATHS,
  BULLET_LIST_ICON_PATHS,
  CHEVRON_LEFT_ICON_PATHS,
  CHEVRON_RIGHT_ICON_PATHS,
  CODE_BLOCK_ICON_PATHS,
  CROSS_REMOVE_ICON_PATHS,
  FORMULA_ICON_PATHS,
  IMAGE_ICON_PATHS,
  INDENT_DECREASE_ICON_PATHS,
  INDENT_INCREASE_ICON_PATHS,
  ITALIC_ICON_PATHS,
  LINK_ICON_PATHS,
  NUMBERED_LIST_ICON_PATHS,
  QUOTE_ICON_PATHS,
  UNDERLINE_ICON_PATHS,
} from "mds/utils/icon-paths";

const SVG_NS = "http://www.w3.org/2000/svg";

export const ICON_SIZE = 16;

export type PathIconSpec = { path: string; width: number; height: number };
export type DomIconSpec = { dom: Node };

function _createPathIconSpec(paths: readonly string[]): PathIconSpec {
  return { path: paths.join(" "), width: ICON_SIZE, height: ICON_SIZE };
}

function _createFillSvg(paths: readonly string[]): SVGSVGElement {
  const svg = document.createElementNS(SVG_NS, "svg");
  svg.setAttribute("viewBox", `0 0 ${ICON_SIZE} ${ICON_SIZE}`);
  svg.setAttribute("width", String(ICON_SIZE));
  svg.setAttribute("height", String(ICON_SIZE));
  svg.setAttribute("fill", "currentColor");
  svg.setAttribute("aria-hidden", "true");
  for (const d of paths) {
    const path = document.createElementNS(SVG_NS, "path");
    path.setAttribute("d", d);
    svg.appendChild(path);
  }
  return svg;
}

function _createStrokeSvg(paths: readonly string[]): SVGSVGElement {
  const svg = document.createElementNS(SVG_NS, "svg");
  svg.setAttribute("viewBox", `0 0 ${ICON_SIZE} ${ICON_SIZE}`);
  svg.setAttribute("width", String(ICON_SIZE));
  svg.setAttribute("height", String(ICON_SIZE));
  svg.setAttribute("fill", "none");
  for (const d of paths) {
    const path = document.createElementNS(SVG_NS, "path");
    path.setAttribute("d", d);
    path.setAttribute("stroke", "currentColor");
    path.setAttribute("stroke-linecap", "round");
    path.setAttribute("stroke-linejoin", "round");
    path.setAttribute("stroke-miterlimit", "10");
    svg.appendChild(path);
  }
  return svg;
}

export function createChevronRightSvg(): SVGSVGElement {
  return _createFillSvg(CHEVRON_RIGHT_ICON_PATHS);
}

export function createChevronLeftSvg(): SVGSVGElement {
  return _createFillSvg(CHEVRON_LEFT_ICON_PATHS);
}

// prosemirror-menu inserts the node as-is, required for stroke icons since the renderer only supports fill.
export const moreOptionsIconSpec = { dom: _createStrokeSvg(ADD_PLUS_ICON_PATHS) };
export const closePanelIconSpec = { dom: _createStrokeSvg(CROSS_REMOVE_ICON_PATHS) };

// prosemirror-menu renders these internally, sufficient for all filled toolbar icons.
export const boldIconSpec = _createPathIconSpec(BOLD_ICON_PATHS);
export const italicIconSpec = _createPathIconSpec(ITALIC_ICON_PATHS);
export const underlineIconSpec = _createPathIconSpec(UNDERLINE_ICON_PATHS);
export const linkIconSpec = _createPathIconSpec(LINK_ICON_PATHS);
export const imageIconSpec = _createPathIconSpec(IMAGE_ICON_PATHS);
export const bulletListIconSpec = _createPathIconSpec(BULLET_LIST_ICON_PATHS);
export const numberedListIconSpec = _createPathIconSpec(NUMBERED_LIST_ICON_PATHS);
export const indentDecreaseIconSpec = _createPathIconSpec(INDENT_DECREASE_ICON_PATHS);
export const indentIncreaseIconSpec = _createPathIconSpec(INDENT_INCREASE_ICON_PATHS);
export const alignLeftIconSpec = _createPathIconSpec(ALIGN_LEFT_ICON_PATHS);
export const alignCenterIconSpec = _createPathIconSpec(ALIGN_CENTER_ICON_PATHS);
export const alignRightIconSpec = _createPathIconSpec(ALIGN_RIGHT_ICON_PATHS);
export const codeBlockIconSpec = _createPathIconSpec(CODE_BLOCK_ICON_PATHS);
export const formulaIconSpec = _createPathIconSpec(FORMULA_ICON_PATHS);
export const quoteIconSpec = _createPathIconSpec(QUOTE_ICON_PATHS);
